<template>
  <div class="dialogBox">
    <div class="triangles"></div>
    <div class="top">
      <div>{{ message.name }}</div>
      <div>
        <img
          src="../assets/diapatch/delete@2x.png"
          alt=""
          style="margin-right: 16px"
          @click="deleteChat"
        />
        <img src="../assets/diapatch/close@2x.png" alt="" @click="closeChat" />
      </div>
    </div>
    <div class="line"></div>
    <div id="scroll-container" ref="scroll_box">
      <div class="infinite-container">
        <infinite-loading
          direction="top"
          @infinite="infiniteHandler"
          :distance="200"
          container=".infinite-container"
        >
        </infinite-loading>
        <div
          class="innerChat"
          ref="scrollContainer"
          v-if="chatHistory.length != 0"
        >
          <!-- recordContent 聊天记录数组-->
          <div
            v-for="(itemc, indexc) in chatHistory"
            :key="indexc"
            @scroll="scrollBtom"
          >
            <!-- 对方 -->
            <div
              class="word"
              v-if="
                itemc.sender_id == message.id &&
                itemc.sender_type == message.type
              "
            >
              <!-- <img :src="itemc.headUrl"/> -->
              <div class="head">{{ message.firstName }}</div>
              <div class="info">
                <!-- <p class="time">
                {{ itemc.nickName }}
              </p> -->
                <div class="info-content" v-if="itemc.msg_type == 1">
                  {{ itemc.content }}
                </div>
                <div
                  class="info-img info-content msg-hover"
                  v-if="itemc.msg_type == 2"
                >
                  <img
                    :src="baseUrl + itemc.content"
                    alt=""
                    @click="openBig(baseUrl + itemc.content)"
                  />
                </div>
                <div
                  class="info-audio info-content msg-hover"
                  v-if="itemc.msg_type == 3"
                  @click="playAudio(indexc, itemc)"
                >
                  <div
                    class="vp-bg-left"
                    :class="
                      indexc == currentVoiceIndex && currentVoicePlay
                        ? 'voicePlay'
                        : ''
                    "
                  ></div>
                  <div style="padding-left: 8px">
                    {{ itemc.audit_time + '"' }}
                  </div>

                  <div class="red" v-if="itemc.is_player == 0"></div>
                  <!-- <img
                    src="../assets/diapatch/voice1@2x.png"
                    alt=""
                    style="margin-right: 16px"
                  /> -->
                  <audio
                    :ref="'recordPlayer' + indexc"
                    controls
                    preload="auto"
                    hidden="true"
                    :src="itemc.content"
                  ></audio>
                </div>
                <!-- <div
                  class="message_time"
                  v-if="
                    indexc - 1 >= 0
                      ? chatHistory[indexc - 1].time < itemc.time - 30000
                      : true
                  "
                >
                  {{ itemc.time }}
                </div> -->
                <div class="message_time">
                  {{ itemc.time }}
                </div>
              </div>
            </div>

            <!-- 我的 -->
            <!--        v-if="itemc.to_user == adminId"-->
            <div class="word-my" v-else>
              <div class="info">
                <div class="info-content" v-if="itemc.msg_type == 1">
                  {{ itemc.content }}
                </div>
                <div
                  class="info-img info-content msg-hover"
                  v-if="itemc.msg_type == 2"
                >
                  <img
                    :src="baseUrl + itemc.content"
                    alt=""
                    @click="openBig(baseUrl + itemc.content)"
                  />
                </div>
                <div
                  class="info-audio info-content msg-hover"
                  v-if="itemc.msg_type == 3"
                  @click="playAudio(indexc, itemc)"
                >
                  <!-- <div class="red"></div> -->
                  <!-- <img src="../assets/diapatch/voice1@2x.png" alt="" /> -->
                  <div style="padding-right: 8px">
                    {{ itemc.audit_time + '"' }}
                  </div>
                  <div
                    class="vp-bg-right"
                    :class="
                      indexc == currentVoiceIndex && currentVoicePlay
                        ? 'voicePlay'
                        : ''
                    "
                  ></div>
                  <audio
                    :ref="'recordPlayer' + indexc"
                    controls
                    preload="auto"
                    hidden="true"
                    :src="itemc.content"
                  ></audio>
                </div>
                <!-- <div
                  class="Sender_time"
                  v-if="
                    indexc - 1 >= 0
                      ? chatHistory[indexc - 1].time < itemc.time - 30000
                      : true
                  "
                >
                  {{ itemc.time_desc }}
                </div> -->
                <div class="Sender_time">
                  {{ itemc.time }}
                </div>
              </div>
              <img v-if="headerUrl == null" src="../assets/1.png" alt="">
              <img v-else :src="headerUrl" />
            </div>
          </div>
        </div>
        <div class="innerChat noChat" v-else>No chats</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="top">
      <div style="width: 224px">
        <el-input
          v-model="input"
          placeholder="Enter..."
          @keyup.enter.native="test($event)"
        ></el-input>
      </div>
      <div>
        <!--      <img src="../assets/diapatch/close@2x.png" alt="" @click="endVoice">-->
        <div class="playVoices">
          <img
            src="../assets/diapatch/voice@2x.png"
            alt=""
            style="margin-right: 16px"
            @mousedown="playVoice"
            @mouseup="endVoice"
          />
        </div>
        <div style="display: inline-block">
          <!-- <el-upload
            class="avatar-uploader"
            action="https://escroud.rapidi.ca/dispatch/upload"
            :headers="config"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          > -->
          <el-upload
            class="avatar-uploader"
            :action="baseUrl + 'dispatch/upload'"
            :headers="config"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <div class="upload">
              <img src="../assets/diapatch/attachment@2x.png" alt="" />
            </div>
          </el-upload>
        </div>
      </div>
    </div>
    <!--图片放大蒙层-->
    <div @click="dialogVisibles = false">
      <el-dialog
        :visible.sync="dialogVisibles"
        :fullscreen="true"
        :show-close="false"
        :modal="false"
      >
        <div class="fullDialog">
          <img :src="img" alt="" />
        </div>
        <span slot="footer" class="dialog-footer"> </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import {
  deleteHeaderDriaverData,
  getChatHistroy,
  sendMeaasge,
  uploadFile,
  playerMsgAudit,
} from "@/api/chatBox";
import { message } from "@/api/resetMessage";
import { uoloadAudio } from "@/api/dispatch";

export default {
  name: "dialogBox",
  components: {
    InfiniteLoading,
  },
  props: {
    message: {
      default: "",
    },
    chatHistory: {
      default: [],
    },
  },
  created() {
    this.headerUrl = localStorage.getItem("avatar");
    this.token = localStorage.getItem("token");
    this.adminId = JSON.parse(localStorage.getItem("userInfo")).aid;
    this.baseUrl = process.env.VUE_APP_BASE_URL;
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },

  computed: {
    config() {
      return { token: this.token };
    },
  },
  data() {
    return {
      adminId: "",
      dialogVisibles: false,
      img: "",
      input: "",
      mediaRecorder: "",
      headerUrl: "",
      token: "",
      topPage: 2,
      startTime: "",
      durationInSeconds: 0,
      baseUrl: "",
      currentVoicePlay: false,
      currentVoiceIndex: "",
      userInfo:{},
    };
  },
  //直接监听chatHistory 如果变化了 将滚动条置底
  watch: {
    chatHistory: {
      deep: true,
      handler(n, o) {
        if (n.length != 0) {
          // let doc = document.getElementById('msg_end')
          // doc.scrollTop = doc.scrollHeight
          // console.log(doc.scrollHeight,'chatListDoc')
          // doc.scrollIntoView(false)
        }
      },
    },
  },
  methods: {
    scrollToBottom() {
      this.$refs.scroll_box.scrollTop = this.$refs.scroll_box.scrollHeight;
    },
    infiniteHandler($state) {
      setTimeout(() => {
        // this.$emit('scrollTop',this.message,$state)
        getChatHistroy({
          receiver_id: this.message.id,
          receiver_type: this.message.type, //接收人类型 0管理员 1门店 2派单员 3司机
          limit: 20,
          page: this.topPage,
        }).then((res) => {
          if (res.code == 200) {
            if (res.data.length) {
              this.topPage += 1;
              this.chatHistory.unshift(...res.data.reverse());
              $state.loaded();
            } else {
              $state.complete();
            }
          }
        });
      }, 1000);
    },
    //滚动带最底部
    scrollBtom(e) {
      this.scrollTop = e.detail.scrollTop;
    },
    test(e) {
      e.preventDefault();
      if (this.input.trim().length) {
        this.sendChat(1, this.input);
        this.input = "";
      } else {
        this.$message({
          type: "warning",
          message: "空白消息不可以发哦",
        });
      }
    },

    //获取当前时间（时区：加拿大渥太华 西五区）
    getCurrentDate() {
      var time = new Date();
      // 获取时间偏移量 getTimezoneOffset 获取格林威治时间   *60000是到毫秒
      var dataOffset = new Date().getTimezoneOffset() * 60000;
      // 获取格林威治时间
      var utc = time.getTime() + dataOffset; // 两个时间戳
      // 拿格林威治时间去反推指定地区时间
      var newTime = utc + 3600000 * -4; // -5西五区
      var times = new Date(newTime);

      let t = times.toDateString();
      var hh = times.getHours(); //小时
      var mM = times.getMinutes(); //分钟
      var time;
      if (hh <= 12) {
        time = "AM"; //小于就是AM
      } else {
        time = "PM"; //大于就是PM
      }
      let timeDes = t.substring(4, t.length) + " " + hh + ":" + mM + "" + time;

      // console.log(timeDes);
      return timeDes;
    },

    //发送聊天消息
    sendChat(type, mes) {
      // console.log('--userinfo--',this.userInfo)

      sendMeaasge({
        receiver_id: this.message.id,
        receiver_type: this.message.type,
        msg_type: type, ////发送类型 1文字 2图片 3语音
        audit_time: this.durationInSeconds,
        content: mes,
        receiver_name:this.userInfo.username,
      }).then((res) => {
        if (res.code == 200) {
          // 已通过WS处理发出的消息 2023年7月24日
          // this.chatHistory.push({
          //   id: this.userInfo.aid,
          //   content: type == 3 ? this.baseUrl + mes : mes,
          //   msg_type: type, //发送类型 1文字 2图片 3语音
          //   headUrl: require("../assets/image/logo@2x.png"),
          //   time: this.getCurrentDate(),
          //   audit_time: this.durationInSeconds,
          // });
          // this.$nextTick(() => {
          //   this.$refs.scroll_box.scrollTop =
          //     this.$refs.scroll_box.scrollHeight;
          // });
        } else {
          // console.log("--消息发送错误--", res);
        }
      });
    },
    handleAvatarSuccess(response, file, fileList) {
      this.sendChat(2, response.data.url);
    },
    openBig(img) {
      this.img = img;
      this.dialogVisibles = true;
    },
    //删除聊天
    deleteChat() {
      this.$emit("closeChat");
      //掉接口 然后将对应的司机从数组中删除
      deleteHeaderDriaverData({
        id: this.message.id,
      }).then((res) => {
        if (res.code == 200) {
          this.$emit("deleteChat", this.message);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //关闭聊天界面
    closeChat() {
      this.$emit("closeChat");
    },
    playVoice() {
      var constrains = {
        audio: true,
      };
      if (navigator.mediaDevices) {
        navigator.mediaDevices
          .getUserMedia(constrains)
          .then((stream) => {
            this.mediaRecorder = new MediaRecorder(stream);
            this.mediaRecorder.addEventListener("dataavailable", (event) => {
              // console.log(event.data, event);
              const audioChunks = [];
              audioChunks.push(event.data);
              const audioBlob = new Blob(audioChunks, {
                type: this.mediaRecorder.mimeType,
              });
              // 创建FormData对象
              const formData = new FormData();
              // 将二进制文件添加到FormData对象中
              formData.append("file", event.data, "audio.wav");
              // console.log(formData, "formData");
              // 创建一个URL对象，用于在浏览器中播放音频或下载文件
              // fetch("https://escroud.rapidi.ca/dispatch/upload", {
              fetch(this.baseUrl + "dispatch/upload", {
                method: "POST",
                body: formData,
                headers: {
                  token: localStorage.getItem("token"),
                },
              })
                .then((response) => {
                  if (response.status == 200) {
                    return response.json();
                  }
                })
                .then((res) => {
                  // console.log(res.data.url, "response.json()");
                  // console.log("--录音时长--", this.durationInSeconds);
                  if (this.durationInSeconds > 1) {
                    this.sendChat(3, res.data.url);
                  } else {
                    this.$message({
                      type: "warning",
                      message: "Please hold down the left mouse button to speak！",
                    });
                  }
                });
            });
            this.startTime = Date.now();
            this.mediaRecorder.start(); //开始录音
          })
          .catch((error) => {
            // this.$alert({ title:'错误', text: '开启麦克风失败！' + error })
            this.$message({
              type: "warning",
              message: "开启麦克风失败！",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "浏览器需要是https",
        });
      }
    },
    //结束录音
    endVoice() {
      this.durationInSeconds = Math.ceil((Date.now() - this.startTime) / 1000);
      this.mediaRecorder.stop();
    },
    //点击播放语音
    playAudio(i, item) {
      this.currentVoicePlay = true;
      this.currentVoiceIndex = i;

      // console.log(i, "播放语音", item);
      let list = eval("this.$refs.recordPlayer" + i);
      list = list.reverse();
      let ref = list[0];
      ref.play();

      this.playerMsgAuditFun(item.id, i);

      setTimeout(() => {
        this.currentVoicePlay = false;
      }, item.audit_time * 1000);
    },

    playerMsgAuditFun(msgId, i) {
      // console.log("--已读消息语音--", msgId, i);
      playerMsgAudit({
        msg_id: msgId,
      }).then((res) => {
        // console.log("---播放语音消息res---", res);
        if (res.code == 200) {
          this.chatHistory[i].is_player = 1;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.dialogBox {
  position: relative;
  /deep/.el-dialog {
    border-radius: 0;
    background-color: RGBA(255, 255, 255, 0.5);
  }
  .triangles {
    position: absolute;
    top: -55px;
    left: 38px;
    width: 0;
    height: 0;
    border-width: 0 15px 15px;
    border-style: solid;
    border-color: transparent transparent #ffffff; /*透明 透明  灰*/
    margin: 40px auto;
  }
  .top {
    width: calc(100% - 32px);
    height: 30px;
    display: flex;
    justify-content: space-between;
    padding: 10px 16px 0;
    .playVoices {
      width: 16px;
      height: 16px;
      display: inline-block;
      border-radius: 50%;
      transform: translateY(-6px);
      margin-right: 8px;
      padding: 8px;
    }
    .playVoices:hover {
      background-color: #e95646;
    }
    .playVoices:active {
      background-color: #e95646;
    }
    .upload {
      width: 16px;
      height: 16px;
      display: inline-block;
      border-radius: 50%;
      transform: translateY(-6px);
    }
    img {
      cursor: pointer;
      width: 16px;
    }
    /deep/.el-input__inner {
      color: #000000;
      background: none;
      border: none;
      margin-top: -10px;
      margin-right: -10px;
    }
    input:focus-visible {
      border: none;
      outline: none;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: #e0e0e0;
  }
  .noChat {
    text-align: center;
    padding-top: 50% !important;
  }
  #msg_end {
    //height: 460px;
    //overflow: auto;
  }
  .infinite-container {
    //height: 460px;
    //overflow: auto;
    //display: flex;
    //flex-direction: column-reverse;
  }
  #scroll-container {
    height: 460px;
    overflow: auto;
  }
  .innerChat {
    height: 100%;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
    .word {
      display: flex;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .info-img {
        img {
          width: 100%;
          height: 100%;
          border-radius: 0;
          border: none;
          margin: 0;
        }
      }
      .info-audio {
        display: flex !important;
        flex-direction: row;
        align-items: center;
        width: 90px;
        height: 18px;
        position: relative;
        .red {
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #e95646;
          // position: absolute;
          // top: 13px;
          // left: 35px;
          margin-left: 18px;
        }
        img {
          width: 16px;
          height: 16px;
          margin-top: 0;
          border: none;
        }
      }
      .head {
        border-radius: 50%;
        width: 32px;
        height: 32px;
        line-height: 32px;
        background: #f5f6fb;
        border: 1px solid #e0e0e0;
        text-align: center;
        margin-right: 6px;
        margin-top: 12px;
      }
      .info {
        margin-left: 10px;
        width: 80%;

        .message_time {
          font-family: SFPro-Regular, SFPro;
          font-weight: 400;
          color: #999999;

          font-size: 12px;
          margin: 0;
          height: 20px;
          line-height: 20px;
        }
        .info-content {
          display: inline-block;
          background: #f5f6fb;
          border: 1px solid #e0e0e0;
          padding: 10px;
          position: relative;
          margin-top: 12px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 400;
          color: #1f2d42;
          word-break: break-all;
          word-wrap: break-word; //在长单词或 URL 地址内部进行换行
          white-space: pre-wrap; //解决浏览器空格合并
        }

        //带边框的小三角形
        .info-content::before {
          box-sizing: content-box;
          width: 0px;
          height: 0px;
          position: absolute;
          top: 10px;
          left: -16px;
          padding: 0;
          border-right: 8px solid #f5f6fb;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-left: 8px solid transparent;
          display: block;
          content: "";
          z-index: 12;
        }
        .info-content::after {
          box-sizing: content-box;
          width: 0px;
          height: 0px;
          position: absolute;
          top: 9px;
          left: -18px;
          padding: 0;
          border-right: 9px solid #cccccc;
          border-top: 9px solid transparent;
          border-bottom: 9px solid transparent;
          border-left: 9px solid transparent;
          display: block;
          content: "";
          z-index: 10;
        }
      }
    }

    .word-my {
      display: flex;
      justify-content: flex-end;
      img {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        //border: 1px solid #999999;
        margin-left: 6px;
        margin-top: 8px;
      }
      .info {
        //width: 90%;
        text-align: right;
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        flex-direction: column;
        .info-content {
          padding: 10px;
          margin-right: 10px;
          position: relative;
          margin-top: 12px;
          text-align: left;
          border-radius: 8px;
          background: #f5f6fb;
          border: 1px solid #e0e0e0;
          font-size: 12px;
          font-weight: 400;
          color: #1f2d42;
          word-break: break-all;
          word-wrap: break-word; //在长单词或 URL 地址内部进行换行
          white-space: pre-wrap; //解决浏览器空格合并
        }
        .info-img {
          img {
            width: 100%;
            height: 100%;
            border-radius: 0;
            border: none;
            margin: 0;
          }
        }
        .info-audio {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;
          width: 90px;
          height: 18px;
          position: relative;
          .red {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #e95646;
            // position: absolute;
            // top: 13px;
            // left: 35px;
            margin-right: 18px;
          }
          img {
            width: 16px;
            height: 16px;
            margin-top: 0;
            border: none;
          }
        }
        .Sender_time {
          font-size: 12px;
          font-family: SFPro-Regular, SFPro;
          font-weight: 400;
          color: #999999;
          line-height: 18px;

          padding-right: 12px;
          padding-top: 5px;
          margin: 0;
          height: 20px;
        }
        //小三角形
        //带边框的小三角形
        .info-content::before {
          box-sizing: content-box;
          width: 0px;
          height: 0px;
          position: absolute;
          top: 10px;
          right: -16px;
          padding: 0;
          border-left: 8px solid #f5f6fb;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-right: 8px solid transparent;
          display: block;
          content: "";
          z-index: 12;
        }
        .info-content::after {
          box-sizing: content-box;
          width: 0px;
          height: 0px;
          position: absolute;
          top: 9px;
          right: -18px;
          padding: 0;
          border-left: 9px solid #cccccc;
          border-top: 9px solid transparent;
          border-bottom: 9px solid transparent;
          border-right: 9px solid transparent;
          display: block;
          content: "";
          z-index: 10;
        }
      }
    }
  }
}
.fullDialog {
  //width: 800px;
  //height: 800px;
  text-align: center;
  img {
    margin: 0 auto;
    max-width: 800px;
    max-height: 950px;
  }
}

.msg-hover:hover {
  cursor: pointer;
}

.vp-bg-right {
  background: url(data:image/png;base64,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)
    right 0 no-repeat;
  width: 20px !important;
  height: 20px !important;
  background-size: 400%;
  transform: rotate(-180deg);
}

.vp-bg-left {
  background: url(data:image/png;base64,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)
    right 0 no-repeat;
  width: 20px !important;
  height: 20px !important;
  background-size: 400%;
  transform: rotate(0deg);
}

.voicePlay {
  animation-name: voicePlay;
  animation-duration: 1s;
  animation-direction: normal;
  animation-iteration-count: infinite;
  animation-timing-function: steps(3);
}

@keyframes voicePlay {
  0% {
    background-position: 0;
  }

  100% {
    background-position: 100%;
  }
}
</style>
